import { useEffect } from 'react'
import { Button, Form, message, Input, InputNumber } from 'antd'
import {Top} from '../../components/Top'
import { useMutation } from '@apollo/client'
import { useUser } from '../../utils/hooks'

import { useNavigate } from 'react-router-dom'
import { CREATE_ONE_REVIEW } from '../../gqls'

const { TextArea } = Input

const requiredRule = { required: true, message: 'Обязательное поле' }
const numberRule = { type: 'number', message: 'Введите число от 1 до 5' }

const CreateReview = () => {
  const { user, loading: loadingMe } = useUser()
  const navigate = useNavigate()

  useEffect(() => {
    if (!user?.role?.canReview) navigate(-1)
  })

  const [createOneReview, { loading }] = useMutation(CREATE_ONE_REVIEW, {
    onCompleted: () => navigate('/reviews'),
    onError: (err) => {
      console.error(err)
      message.error('Не удалось выполнить запрос')
    },
  })

  const handleCreate = (v) => {
    createOneReview({ variables: { data: { ...v } } })
  }

  if (loadingMe) return 'Загрузка...'
  if (!user?.role?.canReview) return 'Ошибка'

  return (
    <>
      <Top title='Добавить отзыв' />
      <div style={{ maxWidth: 500 }}>
        <Form onFinish={handleCreate} layout='vertical'>
          <Form.Item name='title' label='Заголовок' required>
            <Input />
          </Form.Item>
          <Form.Item name='description' label='Описание' required>
            <TextArea />
          </Form.Item>
          <Form.Item  name='rating' label='Рейтинг' rules={[requiredRule, numberRule]}>
            <InputNumber min={1} max={5} defaultValue={5}  />
          </Form.Item>
          <Button loading={loading} htmlType='submit' type='primary'>
            Добавить
          </Button>
        </Form>
      </div>
    </>
  )
}

export default CreateReview
